// Dot levels, from the faintest dithered speck (level 1) to the densest square (level 6).
// Colors are CSS variable names declared on :root in globals.css, so every canvas follows the theme.

export type DotLevel = {
    size: number
    color: string
}

export const DOT_LEVELS: Array<DotLevel> = [
    { size: 0.24, color: '--azure-200' },
    { size: 0.34, color: '--azure-200' },
    { size: 0.46, color: '--azure-300' },
    { size: 0.58, color: '--azure-400' },
    { size: 0.7, color: '--azure-500' },
    { size: 0.82, color: '--azure-600' }
]

const FALLBACK_COLORS: Record<string, string> = {
    '--grid-dot': '#e1e5eb',
    '--azure-200': '#ddd6fe',
    '--azure-300': '#c4b5fd',
    '--azure-400': '#a78bfa',
    '--azure-500': '#7c3aed',
    '--azure-600': '#6d28d9'
}

export const readCssColor = (name: string): string => {
    const fallback = FALLBACK_COLORS[name] ?? '#7c3aed'

    if (typeof window === 'undefined') return fallback

    const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim()

    return value || fallback
}

export const readDotColors = (): Array<string> => DOT_LEVELS.map(level => readCssColor(level.color))
